import React from 'react';
interface ProgressBarProps {
  progress: number;
  answeredQuestions: number;
  totalQuestions: number;
}
const ProgressBar = ({
  progress,
  answeredQuestions,
  totalQuestions
}: ProgressBarProps) => {
  return <div className="px-6 py-5 bg-gray-50 border-b border-gray-200" data-id="element-30">
      <div className="w-full h-5 bg-gray-200 rounded-full overflow-hidden shadow-inner" data-id="element-31">
        <div className="h-full bg-gradient-to-r from-green-500 to-teal-400 rounded-full transition-all duration-500 ease-out" style={{
        width: `${progress}%`
      }} data-id="element-32"></div>
      </div>
      <div className="text-center mt-2 font-semibold text-gray-700" data-id="element-33">
        Question {answeredQuestions} of {totalQuestions} ({Math.round(progress)}
        % Complete)
      </div>
    </div>;
};
export default ProgressBar;